export default __webpack_public_path__ + "static/media/28.2896e546.jpg";